import React from 'react';
import lang from '../Lang/lang.json';

let LangConf = (props) => {
  let languages = lang.languages
  return(
    <div id="langconf">
      <ul>
      {Object.keys(languages).map((element) => {
        return(
          <li key={element} onClick={() => props.changeLang(element)}>
            {languages[element]}
          </li>
        )
      })}
      </ul>
    </div>
  )
}

export default LangConf;


// WEBPACK FOOTER //
// ./src/Components/Admin/LangConf.js